import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { translateTransactionStatus } from '@/utility';

const useTranslatedTransactionStatuses = () => {
  const { t } = useTranslation();

  const getTranslatedStatus = useMemo(() => {
    return (status) => translateTransactionStatus(status, t);
  }, [t]);

  return { getTranslatedStatus };
};

export default useTranslatedTransactionStatuses;
